<template>
  <b-navbar toggleable="md" type="dark" fixed="top" is-nav>
    <div class="container-fluid">
      <b-navbar-brand to="/">
        <span class="code">&lt;</span>
        Mohamed<span style="font-weight: lighter">Sabry</span>
        <span class="code">&#47;&gt;</span>
      </b-navbar-brand>

      <Toggle class="desktop-hidden" :mode="mode" @toggle="$emit('toggle')" />

      <b-navbar-toggle target="nav-collapse">{{ menu }}</b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
          <b-nav-item to="/" exact>{{ home }}</b-nav-item>
          <b-nav-item to="/projects">{{ projects }}</b-nav-item>
          <b-nav-item to="/connect">{{ connect }}</b-nav-item>
        </b-navbar-nav>
        <Toggle class="mobile-hidden" :mode="mode" @toggle="$emit('toggle')" />
      </b-collapse>
    </div>
  </b-navbar>
</template>

<script>
import Toggle from "@/components/Toggle";
export default {
  props: ["mode"],
  components: {
    Toggle
  },
  data() {
    return {
      logoName: "Mohamed Sabry",
      menu: "Menu",
      home: "Home",
      projects: "Projects",
      flags: "Flags",
      connect: "Connect"
    };
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/css/base.scss";

.navbar {
  background-color: transparent;

  .nav-item {
    margin-right: 1rem;
  }

  .nav-link {
    font-weight: 500;
    color: $third-color;
    // margin: 1rem;

    &:hover {
      color: $first-color;
    }

    &.router-link-exact-active {
      color: #2c3e50;
      background-image: linear-gradient(
        transparent 0%,
        transparent calc(50% - 9px),
        rgba(0, 255, 0, 0.35) calc(50% - 9px),
        rgba(0, 255, 0, 0.35) 100%
      );
      transition: all 120ms ease-in-out 0s;
      background-size: 100% 200%;
      background-position: 0 0;
      word-break: break-word;

      &:hover {
        background-image: linear-gradient(
          transparent 0%,
          transparent calc(50% - 9px),
          rgb(0, 255, 0) calc(50% - 9px),
          rgb(0, 255, 0) 100%
        );
        background-position: 0 100%;
      }
    }
  }

  .navbar-nav {
    @media all and (max-width: 720px) {
      height: 100vh;
      justify-content: center;
      align-items: center;
      background-color: #f8f9fa;
    }
  }

  .navbar-brand {
    font-weight: bold;
    font-size: 1em;
    color: $third-color;

    &:hover {
      color: $first-color;

      .code {
        color: #ff7f50;
      }
    }
  }

  .code {
    color: transparent;
    transition: color 0.3s ease-out;
  }

  .links {
    a {
      font-size: 1.8rem;
      font-weight: 600;

      @media all and (min-width: 370px) {
        font-size: 2.2rem;
      }
    }
  }
}

.navbar-toggler {
  background-color: $third-color;
  color: #fff;
  padding: 10px;
  font-weight: 900;
  // outline: none;
}

.theme-mode {
  position: absolute;
  background-color: $third-color;
  color: #f8f9fa;
  top: 50px;
  left: 0;
  padding: 5px;
}
</style>
